import { myQueueDetailMethods } from './my_queue_methods_detail';
import { myQueueEditMethods } from './my_queue_methods_edit';
import { myQueueQueueMethods } from './my_queue_methods_queue';
import { myQueueStatusMethods } from './my_queue_methods_status';

export const myQueueMethods = {
  ...myQueueQueueMethods,
  ...myQueueDetailMethods,
  ...myQueueEditMethods,
  ...myQueueStatusMethods
};
